export enum InceptHeader {
  DefinitionName = 'X-Definition-Name',
  WorkflowName = 'X-Workflow-Name',
  RelatedDefinitionName = 'X-Related-Definition-Name',
  Context = 'X-Incept-Context',
  TwoFactorToken = 'X-2FA-Token',
  Timezone = 'X-Incept-Timezone',
  StatusName = 'X-Status-Name',
  ForwardedFor = 'X-Forwarded-For',
}
